import { Link, useSearchParams } from 'react-router';

/* ============================================================================
   /payment/failed — the other redirect target.
   ----------------------------------------------------------------------------
   Also unreachable until Razorpay is live. The important thing here is that a
   failed payment is not an error message: nothing was lost, nothing was
   charged, and the way out is one tap. A shop owner whose payment failed on
   4G needs to be told it is fine and given the button again.
   ========================================================================== */

export function PaymentFailedPage() {
  const [params] = useSearchParams();
  const invoiceId = params.get('invoice');

  return (
    <section className="card stack center">
      <h1 className="h1">Payment nahi hua</h1>
      <p className="muted">
        Paise nahi kate hain. Dobara koshish kar sakte hain, ya humein WhatsApp par bata dijiye —
        UPI ya cash se bhi le lenge.
      </p>
      <Link className="btn" to={invoiceId ? `/invoices/${invoiceId}` : '/invoices'}>
        Dobara koshish kijiye
      </Link>
      <a className="btn btn--ghost" href="https://wa.me/918630415226">
        WhatsApp kijiye
      </a>
    </section>
  );
}
